import Axios from '../axios'
import appConfig from '../../../app.config'
import { getHeadersWithJwtToken } from '../../../auth/utils/auth-util'
import { TFunction } from 'i18next'
import { logError, showBlob } from '../../../shared'

async function getAccountStatementService(
	accountStatementId: string,
	t: TFunction,
	windowRef: Window | null,
) {
	try {
		let response = await Axios.get<any>(
			`${appConfig.customerDataBaseUrl}/api/creditcard/accountstatement?accountStatementId=${accountStatementId}`,
			{
				...(await getHeadersWithJwtToken()),
				responseType: 'blob',
			},
		)

		let blob = new Blob([response.data], {
			type: 'application/pdf',
		})

		showBlob(blob, windowRef, accountStatementId + '.pdf')
	} catch (e: any) {
		logError(e)
		throw new Error(t('ErrorAccountStatements'))
	}
}

export default getAccountStatementService
